/**
 * Copyright Mántum All Rights Reserved.
 */
import debug from 'debug';
import request from '@mantum/kanela-request';
import { source } from '@mantum/kanela';

import type { DataSource } from '@mantum/kanela';

const logger = debug('kanela:request');

export default function (
    dataSource: DataSource | unknown[] | string
): Promise<unknown[]> {
    return new Promise((resolve, reject) => {
        logger('prepare request %o', dataSource);
        dataSource = typeof dataSource === 'string' ? [] : dataSource;
        if (Array.isArray(dataSource)) {
            resolve(dataSource);
            return;
        }

        logger('fetch %s', dataSource.url);
        const response = request.fetch(dataSource.url, {
            method: dataSource.method,
            body: dataSource.parameter,
            headers: dataSource.headers
        });

        response.then((values: unknown[]) => {
            logger('response request %o', values);
            const namespace =
                typeof dataSource === 'object' && 'namespace' in dataSource
                    ? dataSource.namespace
                    : undefined;

            resolve(source.extract(values, namespace));
        });

        response.catch((error: unknown) => {
            logger('error request %o', error);
            reject(error);
        });
    });
}
